<img width="25" class="table-image" src="{{params.value}}"/>
